export default __webpack_public_path__ + "static/media/send-paperplane_black.5d39b142.svg";